module.exports = __webpack_public_path__ + "static/media/PV.ba6616ac.png";